/*
 * Copyright (c) 2020. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */
import { ROUTE_NAMES } from "./../routes";

const TopLeftMenuItems = [
  {
    label: "Visit us",
    to: { name: ROUTE_NAMES.VISIT_US }
  },
  {
    label: "Events",
    to: { name: ROUTE_NAMES.EVENTS }
  },
  {
    label: "Garden map",
    to: { name: ROUTE_NAMES.GARDEN_MAP }
  },
  {
    label: "Galleries",
    to: { name: ROUTE_NAMES.GALLERIES }
  },
  {
    label: "Expositions",
    to: { name: ROUTE_NAMES.EXPOSITIONS }
  },
  {
    label: "Tours",
    to: { name: ROUTE_NAMES.TOURS }
  },
  // {
  //   label: "Other",
  //   to: {}
  // },
  {
    label: "Contacts",
    to: { name: ROUTE_NAMES.CONTACTS }
  }
];

export { TopLeftMenuItems };
